/** NVD / Genesis vuln_status values used by CVE Browsing. */
export const VULN_STATUS_OPTIONS = [
  "Received",
  "Awaiting Analysis",
  "Undergoing Analysis",
  "Analyzed",
  "Modified",
  "Deferred",
  "Rejected",
];

export const VULN_STATUS_I18N_KEYS = {
  Received: "cve-browsing.vuln-status-received",
  "Awaiting Analysis": "cve-browsing.vuln-status-awaiting-analysis",
  "Undergoing Analysis": "cve-browsing.vuln-status-undergoing-analysis",
  Analyzed: "cve-browsing.vuln-status-analyzed",
  Modified: "cve-browsing.vuln-status-modified",
  Deferred: "cve-browsing.vuln-status-deferred",
  Rejected: "cve-browsing.vuln-status-rejected",
};

export const translateVulnStatus = (t, value, fallback = "-") => {
  if (!value) {
    return fallback;
  }
  const key = VULN_STATUS_I18N_KEYS[value];
  return key ? t(key) : value;
};
